// Import stores
import SessionStore from './SessionStore';
import EnrollmentStore from './EnrollmentStore';
import ExamStore from './ExamStore';
import HelpStore from './HelpStore';
import HybridStore from "./HybridStore";
import LocationStore from './LocationStore';
import ManagerStore from './ManagerStore';
import MessageStore from './MessageStore';
import PaymentStore from './PaymentStore';
import PolicyStore from './PolicyStore';
import RegisterStore from './RegisterStore';
import ReportStore from './ReportStore';
import ReviewStore from './ReviewStore';
import ScheduleStore from './ScheduleStore';
import SettingsStore from './SettingsStore';
import TicketStore from './TicketStore';

// Combine stores
const store = {
  SessionStore,
  EnrollmentStore,
  ExamStore,
  HelpStore,
  HybridStore,
  LocationStore,
  ManagerStore,
  MessageStore,
  PaymentStore,
  PolicyStore,
  RegisterStore,
  ReportStore,
  ReviewStore,
  ScheduleStore,
  SettingsStore,
  TicketStore
};

export default store;



// WEBPACK FOOTER //
// ./src/app/stores/index.js